import { ClienteFilter } from '../../filter';

export class ClienteContatoExcelExportModal {
    nomeExportacao: string;
    filter: ClienteFilter;

    constructor(filter: ClienteFilter) {
        this.filter = filter;
    }
}
